document.addEventListener('DOMContentLoaded', function () {
  const hotspots = document.querySelectorAll('[data-hotspot]');
  const popups = document.querySelectorAll('[data-popup]');

  function closeAllPopups() {
    popups.forEach(function (popup) {
      popup.classList.remove('is-active', 'is-shift-left', 'is-shift-right', 'is-shift-down', 'is-floating');

      popup.style.removeProperty('--popup-left');
      popup.style.removeProperty('--popup-top');
    });

    hotspots.forEach(function (hotspot) {
      hotspot.classList.remove('is-active');
    });

    document.querySelectorAll('[data-outfit-wrap]').forEach(function (wrap) {
      wrap.classList.remove('has-active-popup');
    });

    document.querySelectorAll('.outfit-carousel-card').forEach(function (card) {
      card.classList.remove('has-active-popup');
    });
  }

  hotspots.forEach(function (hotspot) {
    hotspot.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const hotspotId = hotspot.getAttribute('data-hotspot-id');
      const popup = document.querySelector('[data-popup="' + hotspotId + '"]');

      if (!popup) return;

      const isActive = popup.classList.contains('is-active');

      closeAllPopups();

      if (!isActive) {
        popup.classList.add('is-active');
        hotspot.classList.add('is-active');

        if (window.innerWidth <= 749 && hotspot.closest('.outfit-carousel')) {
          if (!popup.dataset.originalParentId) {
            const parent = popup.parentElement;

            if (!parent.dataset.popupParentId) {
              parent.dataset.popupParentId = 'popup-parent-' + Math.random().toString(36).slice(2);
            }

            popup.dataset.originalParentId = parent.dataset.popupParentId;
          }

          document.body.appendChild(popup);

          const hotspotRect = hotspot.getBoundingClientRect();
          const popupWidth = popup.offsetWidth || 220;
          const popupHeight = popup.offsetHeight || 260;

          let left = hotspotRect.right + 16;
          let top = hotspotRect.bottom + 16;

          if (left + popupWidth > window.innerWidth - 12) {
            left = hotspotRect.left - popupWidth - 16;
          }

          if (left < 12) {
            left = 12;
          }

          if (top + popupHeight > window.innerHeight - 12) {
            top = hotspotRect.top - popupHeight - 16;
          }

          if (top < 12) {
            top = 12;
          }

          popup.style.setProperty('--popup-left', left + 'px');
          popup.style.setProperty('--popup-top', top + 'px');
          popup.classList.add('is-floating');
        }

        const wrap = hotspot.closest('[data-outfit-wrap]');
        const card = hotspot.closest('.outfit-carousel-card');

        if (wrap) {
          wrap.classList.add('has-active-popup');
        }

        if (card) {
          card.classList.add('has-active-popup');
        }

        popup.classList.remove('is-shift-left', 'is-shift-right', 'is-shift-down');

        requestAnimationFrame(function () {
          const rect = popup.getBoundingClientRect();

          if (rect.left < 12) {
            popup.classList.add('is-shift-right');
          }

          if (rect.right > window.innerWidth - 12) {
            popup.classList.add('is-shift-left');
          }

          if (rect.top < 12) {
            popup.classList.add('is-shift-down');
          }

          const container = popup.closest('[data-outfit-wrap], .outfit-carousel-card, .outfits-list-card__image-wrap');

          if (container) {
            const containerRect = container.getBoundingClientRect();

            if (rect.bottom > containerRect.bottom - 12) {
              popup.classList.add('is-shift-down');
            }
          }
        });
      }
    });
  });

  document.querySelectorAll('[data-popup-close]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeAllPopups();
    });
  });

  document.addEventListener('click', function () {
    closeAllPopups();
  });

  document.querySelectorAll('.outfit-popup').forEach(function (popup) {
    popup.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  });

  const params = new URLSearchParams(window.location.search);
  const isHotspotDebug = params.get('debug_hotspots') === 'true';

  if (isHotspotDebug) {
    document.body.classList.add('outfit-debug-active');

    document.querySelectorAll('[data-outfit-position-image]').forEach(function (image) {
      image.addEventListener('click', function (event) {
        const rect = image.getBoundingClientRect();

        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;

        let panel = document.querySelector('[data-hotspot-debug-panel]');

        if (!panel) {
          panel = document.createElement('div');
          panel.setAttribute('data-hotspot-debug-panel', '');
          panel.className = 'outfit-debug-panel';
          document.body.appendChild(panel);
        }

        panel.innerHTML =
          '<strong>Hotspot pozice</strong><br>' +
          'X: <code>' + x.toFixed(1) + '</code><br>' +
          'Y: <code>' + y.toFixed(1) + '</code><br>' +
          '<small>Zkopírujte hodnoty do hotspot metaobjectu.</small>';

        console.log('Hotspot X:', x.toFixed(1), 'Y:', y.toFixed(1));
      });
    });
  }

});